import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

/** 快速切换菜单/重复跳转时 vue-router 会 reject，属正常情况 */
export function isBenignNavError (err) {
  if (!err) return true
  if (VueRouter.isNavigationFailure) {
    return VueRouter.isNavigationFailure(
      err,
      VueRouter.NavigationFailureType.redirected |
      VueRouter.NavigationFailureType.duplicated |
      VueRouter.NavigationFailureType.cancelled |
      VueRouter.NavigationFailureType.aborted
    )
  }
  const msg = err.message || ''
  return msg.includes('Redirected when going from') ||
    msg.includes('Avoided redundant navigation') ||
    msg.includes('Navigation cancelled') ||
    msg.includes('with a new navigation') ||
    err.name === 'NavigationDuplicated'
}

function patchNavigation (router) {
  const originalPush = router.push.bind(router)
  const originalReplace = router.replace.bind(router)
  router.push = function push (location, onResolve, onReject) {
    if (onResolve || onReject) {
      return originalPush(location, onResolve, onReject)
    }
    return originalPush(location).catch(err => {
      if (isBenignNavError(err)) return err
      return Promise.reject(err)
    })
  }
  router.replace = function replace (location, onResolve, onReject) {
    if (onResolve || onReject) {
      return originalReplace(location, onResolve, onReject)
    }
    return originalReplace(location).catch(err => {
      if (isBenignNavError(err)) return err
      return Promise.reject(err)
    })
  }
}

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { public: true }
  },
  {
    path: '/',
    name: 'Root',
    // 异步加载，避免与 layout → permission → router 形成循环依赖
    component: () => import('@/layouts/BasicLayout.vue'),
    redirect: '/dashboard',
    children: []
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

patchNavigation(router)

/** 动态路由是否已注入（退出登录后需重置） */
let routesAdded = false

export function isRoutesAdded () {
  return routesAdded
}

export function setRoutesAdded (val) {
  routesAdded = !!val
}

export function resetRouter () {
  const newRouter = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
  })
  router.matcher = newRouter.matcher
  routesAdded = false
}

/** 退出登录时清空动态路由标记 */
export function markRoutesNeedReset () {
  resetRouter()
}

export default router
